import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";

const articleSlugs = [
  'basetao-spreadsheet-guide',
  'basetao-review',
  'basetao-shipping-cost',
  'basetao-coupon',
  'basetao-warehouse',
  'is-basetao-legit',
  'basetao-finds',
  'basetao-alternatives',
  'basetao-shipping-calculator',
  'basetao-beginner-guide',
  'basetao-vs-superbuy',
  'basetao-vs-sugargoo',
  'basetao-vs-pandabuy',
  'basetao-europe-shipping',
  'basetao-usa-shipping',
  'basetao-qc-photos',
  'basetao-tracking-guide',
  'budget-basetao-finds',
  'basetao-spreadsheet-tips',
  'basetao-discount-code',
];

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...articleSlugs.map((slug) => ({
    path: `/${slug}`,
    element: <ArticlePage />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;